import { createApiRef } from '@backstage/core-plugin-api';
import { AccessControlListApi } from '@agilelab/plugin-wb-access-control-common';

export const accessControlListApiRef = createApiRef<AccessControlListApi>({
  id: 'wb-access-control',
});
